import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {
  setSelectedBan,
  submitOwnershipTransfer,
  setCurrentPopUp,
  setCollaborationApproval,
  setShowPopUp,
} from '../OwnershipTransferBuyerSlice';
import SelectOptionButton from '../../../Shared/SelectOptionButton/SelectOptionButton';
import {ScopeName, ServiceType, CollapseLabelCheckBox, PopupEnum, PopupMessageContent} from '../Constant/Constant';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import {buildUrlAndOpenWindow} from '../../../../utilities/StringHelpers/StringHelpers';
import Config from 'app/Config';
import ThirdParty from '../../../Shared/ThirdParty/ThirdParty';
import CheckboxCollapseLabel from 'app/Components/Shared/CheckboxCollapseLabel/CheckboxCollapseLabel';
import CheckBox from '../../../Shared/CheckBox/Checkbox';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import {dwhGeneralReport, DWHStatus, DwhActionType, DWHMessageText} from '../Reports/dwhReports';

const Ban = ({ban, selected, onClick}) => {
  const billingAddressTitle = () => {
    if (ban.billingAddress.startsWith('05')) {
      return 'החשבונית נשלחת לטלפון';
    } else return 'החשבונית נשלחת לכתובת מייל';
  };
  const paymentToken = () => {
    if (ban.paymentType == 'PAYPAL') {
      return `חשבון פייפאל ${ban.paymentToken}`;
    } else {
      return ban.paymentToken;
    }
  };
  return (
    <div className={`ownership-transfer-ban ${selected ? 'selected' : ''}`} onClick={() => onClick(ban.ban)}>
      <div className='ownership-transfer-ban-title semi'>
        <span>פרטי חשבונית: </span>
        <span className='mr-1'>{ban.banData}</span>
      </div>
      <div className='ownership-transfer-ban-row ownership-transfer-ban-billing-address'>
        <span className='billing-address-title'>{billingAddressTitle()}:</span>
        <span className='billing-address-value'>{ban.billingAddress}</span>
      </div>
      <div className='ownership-transfer-ban-row ownership-transfer-ban-payment'>
        <span className='payment-title'>החיוב ירד מאמצעי התשלום בו מחוייב חשבונך</span>
        <span className='payment-value'>{paymentToken()}</span>
      </div>
    </div>
  );
};

const SelectBan = (props) => {
  const [errorText, setErrorText] = useState('');
  const [showErrorMsg, setShowErrorMsg] = useState(false);
  const [checkbox, setCheckbox] = useState([
    {
      id: 0,
      title: (
        <div className='checkboxes-title'>
          קראתי ואני מסכימ/ה ל
          <a href='#' className='link' onClick={() => buildUrlAndOpenWindow(props.data.selectedPricePlan.programDetailsLink)}>
            עיקרי פרטי התכנית
          </a>
          ,ל
          <a href='#' className='link' onClick={() => buildUrlAndOpenWindow(props.data.selectedPricePlan.connectionAgreementLink)}>
            הסכם ההתקשרות
          </a>
          ו
          <a
            href='#'
            className='link'
            onClick={() => (Config.cooperationTermsLink ? buildUrlAndOpenWindow(Config.cooperationTermsLink) : null)}>
            לתנאים הכלליים*
          </a>
        </div>
      ),
      checked: false,
    },
    {
      id: 1,
      title: (
        <div className='checkboxes-title'>
          <CheckboxCollapseLabel
            defaultText={
              props.data.serviceType == ServiceType.StationaryLine
                ? CollapseLabelCheckBox.stationary.defaultText
                : CollapseLabelCheckBox.cellular.defaultText
            }
            extendedText={
              props.data.serviceType == ServiceType.StationaryLine
                ? CollapseLabelCheckBox.stationary.extendedText
                : CollapseLabelCheckBox.cellular.extendedText
            }
          />
        </div>
      ),
      checked: false,
    },
    {
      id: 2,
      title: (
        <div className='checkboxes-title'>
          <ThirdParty />
        </div>
      ),
      checked: false,
    },
  ]);
  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      dwhGeneralReport({
        data: {...props.data, userDetails: props.userDetails},
        actionType: DwhActionType.ChooseBanPage,
        messageText: DWHMessageText.ChooseBanPageDisplayed,
        status: DWHStatus.Ongoing,
      });
    }
  }, []);

  useEffect(() => {
    if (props.data.simResponsibilities) {
      submitOwnershipTransfer();
      props.setShowPopUp(false);
    }
  }, [props.data.simResponsibilities]);

  const title = () => {
    if (props.data.serviceType == ServiceType.Cellular) {
      return 'לאיזה חשבון לשייך את החבילה?';
    } else {
      return 'לאיזה חשבון לשייך את השירות?';
    }
  };

  function validateRequiredData() {
    if (!props.data.selectedBan) {
      setErrorText('כדי להמשיך יש לבחור את מספר הלקוח');
      return false;
    } else if (
      (props.data.serviceType == ServiceType.Cellular && !checkbox.find((ch) => ch.id == 0).checked) ||
      !checkbox.find((ch) => ch.id == 1).checked
    ) {
      setErrorText('חובה לאשר את העברת הבעלות והתנאים הכלליים');
    } else {
      setErrorText('');
      return true;
    }
  }

  function nextStep() {
    if (!validateRequiredData()) {
      setShowErrorMsg(true);
    } else {
      dwhGeneralReport({
        data: {...props.data, userDetails: props.userDetails},
        actionType: DwhActionType.ChooseBanPage,
        messageText: DWHMessageText.ChooseBanPageButtonClicked,
        status: DWHStatus.Ongoing,
      });
      if (props.data.serviceType == ServiceType.Cellular) {
        //open Popup
        props.setCurrentPopUp({
          currentPopupData: PopupMessageContent.SimResponsibilities,
          currentPopUp: PopupEnum.MessagePopup,
        });
      } else {
        submitOwnershipTransfer();
      }
    }
  }

  function onCheck(index) {
    let temp = [...checkbox];
    temp[index].checked = !temp[index].checked;
    setCheckbox(temp);
    setShowErrorMsg(false);
    if (index == 2) {
      props.setCollaborationApproval(temp[index].checked);
    }
  }

  function submitOwnershipTransfer() {
    const transferReq = {
      OrderId: props.data.orderId,
      SelectedBan: props.data.selectedBan,
      CollaborationApproval: props.data.collaborationApproval,
      OfferId: props.data.serviceType == ServiceType.Cellular ? props.data.selectedPricePlan.offerID : '',
    };
    props.submitOwnershipTransfer(transferReq);
  }

  return (
    <div className='ownership-transfer-select-ban  ownership-transfer-step '>
      {props.data.banList.length > 0 && (
        <>
          <div className='l-title '>{title()}</div>

          {props.data.banList.map((ban, index) => (
            <Ban key={index} ban={ban} selected={props.data.selectedBan == ban.ban} onClick={props.setSelectedBan} />
          ))}

          <div className='checkboxes'>
            {checkbox.map((item, index) => {
              if (props.data.serviceType == ServiceType.StationaryLine && item.id == 0) return null;
              if (props.data.needsToSignCollaborationApproval === false && item.id == 2) return null;
              else
                return (
                  <div className='transfer-checkbox' key={index}>
                    <CheckBox
                      id={index}
                      onCheck={() => onCheck(index)}
                      onUncheck={() => onCheck(index)}
                      checked={item.checked}
                      label={item.title}
                    />
                  </div>
                );
            })}
          </div>

          <div className='continue-button'>
            {showErrorMsg && <div className='error center'>{errorText}</div>}
            <BtnSubmit onclick={nextStep} text={'אישור וסיום'} />
          </div>
        </>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  data: state.OwnershipTransferPrivateBuyer,
  userDetails: state.authentication?.loginData,
});

const mapDispatchToProps = {
  setSelectedBan,
  submitOwnershipTransfer,
  setCurrentPopUp,
  setCollaborationApproval,
  setShowPopUp,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectBan);
